import { ALLOW_ADMIN_EDITING, IS_ADMIN_USER, ROLES } from "../../../ducks/login";

import {
  convertPDFsAndZip,
  downloadSurveysPdfArchive,
  removePDFConversionData,
  START_CONVERSION,
  SURVEY_SUBMISSIONS,
  TEMPLATES
} from "../../../ducks/collapsibleTableChart";

import {
  deleteReport,
  downloadReportingStatus,
  FILTERS,
  LIST,
  loadDetails,
  LOADED,
  loadOverview,
  propertyChange as overviewPropertyChange,
  SORT_TABLE_TEMPLATE,
  SORT_TABLE_TEMPLATE_ASCENDING,
  SORT_TABLE_TEMPLATE_BY,
  sortColumn,
} from "../../../ducks/respondentsOverview";

import {
  hideReadOnlyDialog,
  loadSurveyResult,
  LOCK_BY_USER,
  LOCK_FROM,
  lockInfoOfSurvey,
  READ_ONLY,
  SHOW_READ_ONLY_DIALOG
} from "../../../ducks/surveyRunner";

import {
  FUNDING_AREA_LIST,
  SELECTED_FUNDING_AREA,
  SELECTED_PROGRAM,
  SELECTED_PROGRAM_INSTANCE,
  SELECTED_PROJECT
} from "../../../ducks/fundingArea";

import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { showDialog } from "../../../ducks/confirmDialog";
import { messagesReceived } from "../../../ducks/message";
import { SURVEY_NAME } from "../../../ducks/survey";
import { propertyChange } from "../../../ducks/surveyView";
import RespondentsOverview from "./RespondentsOverview";
import { shouldShowLecturer } from "../../../utils/RespondentsOverviewUtils";

import { useLayoutEffect } from "react";
import { COUNTRY_OPTIONS, loadCountries } from "../../../ducks/country";
import { loadRegions, REGION_OPTIONS } from "../../../ducks/regions";

import { COUNTRY_STORE, LOGIN_STORE, REGION_STORE } from "../../../common/constant";
import { beginLoading, endLoading } from "../../../ducks/loadingSpinner";
import { IS_LOGGED_IN_KEY } from "../../../ducks/login";

const mapStateToProps = (state) => {
  return {
    list: state.respondentsOverview[LIST],
    filters: state.respondentsOverview[FILTERS],
    sort: state.respondentsOverview["sort"],
    sortTableTemplate: state.respondentsOverview[SORT_TABLE_TEMPLATE],
    sortTableTemplateBy: state.respondentsOverview[SORT_TABLE_TEMPLATE_BY],
    sortTableTemplateAscending: state.respondentsOverview[SORT_TABLE_TEMPLATE_ASCENDING],
    showReadOnlyDialog: state.surveyRunner[SHOW_READ_ONLY_DIALOG],
    readOnly: state.surveyRunner[READ_ONLY],
    lockByUser: state.surveyRunner[LOCK_BY_USER],
    lockFrom: state.surveyRunner[LOCK_FROM],
    isAdminUser: state.login[IS_ADMIN_USER],
    allowAdminEditing: state.login[ALLOW_ADMIN_EDITING],
    surveyName: state.survey[SURVEY_NAME],
    roles: state.login[ROLES],
    [LOADED]: state.respondentsOverview[LOADED],
    selectedFundingArea: state.fundingArea[SELECTED_FUNDING_AREA],
    selectedProgram: state.fundingArea[SELECTED_PROGRAM],
    showLecturer: shouldShowLecturer(
      state.fundingArea[SELECTED_PROGRAM]?.overview,
      state.fundingArea[FUNDING_AREA_LIST]?.overview
    ),
    selectedProgramInstance: state.fundingArea[SELECTED_PROGRAM_INSTANCE],
    selectedLocation: state.fundingArea[SELECTED_PROJECT],
    countryOptions: state[COUNTRY_STORE][COUNTRY_OPTIONS],
    regionsOptions: state[REGION_STORE][REGION_OPTIONS],
    surveyTemplates: state.collapsibleTableChart[TEMPLATES],
    startConversion: state.collapsibleTableChart[START_CONVERSION],
    surveySubmissions: state.collapsibleTableChart[SURVEY_SUBMISSIONS]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadOverview,
      loadDetails,
      showDialog,
      sortColumn,
      propertyChange,
      lockInfoOfSurvey,
      hideReadOnlyDialog,
      loadSurveyResult,
      overviewPropertyChange,
      messagesReceived,
      downloadReportingStatus,
      deleteReport,
      loadRegions,
      loadCountries,
      downloadSurveysPdfArchive,
      convertPDFsAndZip,
      removePDFConversionData,
      endLoading,
      beginLoading
    },
    dispatch
  );
};

const RespondentsOverviewContainer = connect(mapStateToProps, mapDispatchToProps)(RespondentsOverview);

const RespondentsOverviewLoader = () => {
  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state) => state[LOGIN_STORE][IS_LOGGED_IN_KEY]);

  useLayoutEffect(() => {
    if (isLoggedIn) {
      dispatch(loadCountries());
      dispatch(loadRegions());
    }

  }, [isLoggedIn, dispatch]);

  return <RespondentsOverviewContainer />;
};

export default RespondentsOverviewLoader;

